import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { renderBootError } from './app/boot-error';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    renderBootError(err);
    console.error(err);
  });
